"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAjvInstanceInternal = void 0;
exports.isValidJSONSchema = isValidJSONSchema;
exports.validateWithCompiledSchema = validateWithCompiledSchema;
exports.validateFieldAgainstSchema = validateFieldAgainstSchema;
const ajv_1 = __importDefault(require("ajv"));
const ajv_formats_1 = __importDefault(require("ajv-formats"));
/**
 * Creates a fresh Ajv instance for validation
 */
const createAjvInstanceInternal = () => {
    const ajv = new ajv_1.default({
        strict: true,
        allErrors: false, // Return only the first error, not all
        code: { optimize: true }, // Enable code optimization to improve performance and reduce DoS risk
        validateFormats: false, // Prevent ReDoS via format validators
    });
    (0, ajv_formats_1.default)(ajv); // Formats added but not validated
    return ajv;
};
exports.createAjvInstanceInternal = createAjvInstanceInternal;
/**
 * Validates if a given object is a valid JSON Schema
 * Used by Zod schema validation
 * Can be used in both client and server contexts
 */
function isValidJSONSchema(schema) {
    try {
        const stringified = JSON.stringify(schema);
        if (stringified.length > 10_000)
            return false; // Schema too large
        const ajv = (0, exports.createAjvInstanceInternal)();
        // This will throw an error if the schema is invalid
        ajv.compile(schema);
        return true;
    }
    catch {
        return false;
    }
}
/**
 * Validates data against a compiled schema validator
 * Optimized for reuse - compiles schema once, validates many times
 */
function validateWithCompiledSchema(data, validator) {
    const isValid = validator(data);
    if (!isValid && validator.errors) {
        return {
            isValid: false,
            errors: validator.errors.map((err) => ({
                path: err.instancePath || "/",
                message: err.message || "Validation failed",
                keyword: err.keyword,
            })),
        };
    }
    return { isValid: true };
}
/**
 * Validates a single field against a JSON schema
 * Creates a fresh Ajv instance for each validation
 * Use this for one-off validations (e.g., single item create/update)
 */
function validateFieldAgainstSchema(params) {
    const { data, schema } = params;
    const ajv = (0, exports.createAjvInstanceInternal)();
    const validate = ajv.compile(schema);
    return validateWithCompiledSchema(data, validate);
}
